import React, { useState } from "react";
import { Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AiToolsPanel from "@/components/resume-builder/AiToolsPanel";

/** Floating AI Tools button — always visible in BOTH Wizard and Advanced mode. Positioned at
 * bottom-24 LEFT (not the conventional bottom-right) since that corner is already occupied by
 * the platform's "Made with Emergent" badge, the global AI Mentor bubble, and the WhatsApp
 * button (see App.js) — this avoids all of those overlaps. In wizard mode it simply jumps to
 * Step 4 (which already renders AiToolsPanel inline) to avoid mounting the panel twice at once;
 * in Advanced mode it opens AiToolsPanel inside a dialog. */
export default function AiToolsFab({ draft, setDraft, setActiveVersionId, mode, onJumpToWizardStep }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (mode === "wizard") {
      onJumpToWizardStep();
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <button
        onClick={handleClick} data-testid="resume-ai-tools-fab-button"
        className="fixed bottom-24 left-6 z-40 flex items-center gap-2 bg-indigo-500 hover:bg-indigo-400 text-white text-sm font-semibold px-5 py-3 rounded-full shadow-lg shadow-indigo-500/30 transition-transform hover:scale-105"
      >
        <Sparkles className="w-4 h-4" /> AI Tools
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid="resume-ai-tools-dialog">
          <DialogTitle className="sr-only">AI Tools</DialogTitle>
          <AiToolsPanel draft={draft} setDraft={setDraft} setActiveVersionId={setActiveVersionId} />
        </DialogContent>
      </Dialog>
    </>
  );
}
